<template>
  <div class="box-content">
    <!-- <h1>帳號已過期<br/>續費後才能發佈全景作品</h1>
    <a-button class="edit-btn" type="primary" @click="onClickTopup">前去續費</a-button> -->
    <a-result status="warning" :title="$t('common.renewAlert')" >
    <template #extra>
      {{$t('common.renewInfo')}} <a @click="onClickTopup">{{$t('common.memberCenter')}}</a> {{$t('actionTitles.renew')}}
    </template>
  </a-result>
  </div>
</template>

<script>
  export default {
    methods: {
      onClickTopup() {
        if(this.$isMobile()) {
          this.$router.push({path: '/mobile'})
        } else {
          this.$router.push({name: 'member-account'})
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.box-content{
    display: flex;
    flex-wrap: wrap;
    width: 200px;
    justify-content: center;
    h1{
      width: 100%;
      font-size: 14px;
      color: #c10909;
      text-align: center;
      margin: 15px 0;
    }
    .edit-btn,.publish-btn{
      width: 100%;
      font-size: 16px;
      height: 38px;
    }
  }
</style>